import Vue from 'vue';
import $ from 'jquery';
import Gallery2 from './Gallery2';
import getStamp from "../stamp/get-stamp";

const vueGalleries = [];

// Bootstrap Galleries2
$('.gallery2').not('.vuetified').each((index, gallery) => {
    const $gallery = $(gallery);
    const sources = [];
    $gallery.children('img').each((index, img) => {
        const $img = $(img);
        sources.push({
            src: $img.attr('src'),
            alt: $img.attr('alt'),
        });
    });

    const stamp = getStamp($gallery);

    const vueGallery = new Vue({
        render (h) {
            return h(Gallery2, {
                props: {
                    images: sources,
                    stamp: stamp,
                }
            });
        }
    });

    vueGallery.$mount(gallery);

    vueGalleries.push(vueGallery);
});
